<template>
  <div class="content-markdown" v-html="markdown"></div>
</template>

<script type="text/babel">
export default {
  props: ["markdown"]
};
</script>
<style lang="less" type="text/less">
.content-markdown > h1,
.content-markdown > h2,
.content-markdown > h3,
.content-markdown > h4,
.content-markdown > h5,
.content-markdown > h6 {
  @apply mt-6 mb-2 font-semibold;
}

.content-markdown > *:first-child{
  margin-top: 0!important;
}
.content-markdown > *:last-child{
  margin-bottom: 0!important;
}


.content-markdown img {
  @apply mt-4 mb-4;

  @media screen(sm) {
    @apply mt-10;
  }
}

.content-markdown a{
  text-decoration: underline;
}

.content-markdown ol {
  @apply mt-3 ml-3 mb-3 list-decimal list-inside;
}

.content-markdown ul {
  @apply mt-3 ml-3 mb-3 list-disc list-inside;
}

.content-markdown > h1 {
  @apply text-2xl;

  @media screen(sm) {
    @apply text-3xl;
  }
}

.content-markdown > h2 {
  @apply text-xl;

  @media screen(sm) {
    @apply text-xl;
  }
}

.content-markdown > h3 {
  @apply text-base;

  @media screen(sm) {
    @apply text-base;
  }
}

.content-markdown > h4 {
  @apply text-base;

  @media screen(sm) {
    @apply text-base;
  }
}

.content-markdown > h5 {
  @apply text-base;

  @media screen(sm) {
    @apply text-base;
  }
}

.content-markdown > p {
  @apply mb-4 text-base font-medium;

  @media screen(sm) {
    @apply text-base;
  }
}
</style>